import { createSelector } from '@ngrx/store';

export const getFormsState = createSelector(
    (state: any) => state.forms,
    (state: any) => state.get('list')
);

export const getCreateFormState = createSelector(
    (state: any) => state.forms,
    (state: any) => state.get('createForm')
);

export const getUpdateFormState = createSelector(
    (state: any) => state.forms,
    (state: any) => state.get('updateForm')
);
